// Imports
import { TrimesterOverview } from "src/modules/trimester-overview/jsx/component.jsx";
import { ProgressSection } from "src/modules/progress-section/jsx/component.jsx";
import { MIPN } from "src/modules/mipn/jsx/component.jsx";


// Stateful components

export function ProgramContent(props) {


    //
    // Render
    //

    var program_index = props['index'];

    return (
        <>
            <ProgressSection index={program_index} />
            <MIPN index={program_index} />
            <TrimesterOverview index={program_index} />
        </>
    );

}
